import 'uni-pages';
import Vue from 'vue'
import Page from './pages/personalCenter/myIntegral.vue'
createPage(Page)